import { render, staticRenderFns } from "./RecordComments.vue?vue&type=template&id=f4b25298&scoped=true"
import script from "./RecordComments.vue?vue&type=script&lang=js"
export * from "./RecordComments.vue?vue&type=script&lang=js"
import style0 from "./RecordComments.vue?vue&type=style&index=0&id=f4b25298&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b25298",
  null
  
)

export default component.exports